// extracted by mini-css-extract-plugin
module.exports = {"groups-list":"uG9OAg_EvfPYdTgeX9Wr9","group-list-element":"_1w6YZgxa0T9qawOCbMo-8D","limit-input-container":"_2JYq27UKCaQZi_xS8yRD8Q"};